style= require('./team-picker.styl')
.team-picker
  .player.all
    .name= team.name
    each status in statuses
      .status
        label(class=status)
          = statusWords[status]
          input(
            type="radio",
            name="all",
            (click)=this.select('all', status))
  each player, $index in sortedPlayers
    - var lineup = this.getLineup(player)
    if this.playerPrices[player]
      - var price = this.playerPrices[player].prices[match]
      .player(class=this.playerClass(lineup))
        .price= ((price && +price.price) || 0).toFixed(1)
        .position (#{player.pos})
        .shirt
          if (player.shirt === 0) || player.shirt
            | #{player.shirt}.
        .name= player.formalName
        each status in statuses
          .status
            label(class=status)
              = statusWords[status]
              input(
                type="radio",
                name=("player-" + player._id),
                [checked]=this.isChecked(player, status),
                (click)=this.select(player, status))
